<template>
  <div>
    <h3 class="field-label">{{ question.label }}</h3>
    <div class="field-value" v-html="formattedValue" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '-',
    },
    question: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedValue() {
      if (this.value === null || this.value === undefined || this.value === '')
        return this.emptyValuePlaceholder
      else return this.value.replace(/\n/gi, '<br>')
    },
    emptyValuePlaceholder() {
      return this.question?.config?.emptyValuePlaceholder || '-'
    },
  },
}
</script>
